import { Box, Icon, Text, Tooltip } from '@timelyapp/react';
import classNames from 'classnames';
import React from 'react';
import styles from './column.module.scss';
import { COLUMN_SIZE_SMALL } from './constants';
import HeaderWithMenu from './HeaderWithMenu';
import type { DatatableCellRenderer, DatatableColumnGetter } from './types';

interface PartialRowData {
  isDayLocked?: boolean;
}

export const getDateColumn: DatatableColumnGetter<string, { label: string }, PartialRowData> = (
  id: string,
  { label } = { label: 'Date' }
) => ({
  id,
  header: props => (
    <HeaderWithMenu
      {...props}
      label={label}
      sortLabelType="date"
      filterTriggerSelector='[data-testid="date_picker_dropdown_target"]'
    />
  ),
  size: COLUMN_SIZE_SMALL,
  minSize: COLUMN_SIZE_SMALL,
  maxSize: COLUMN_SIZE_SMALL,
  enableResizing: false,
  meta: {
    numeric: false,
    mandatory: true,
  },
  cell: DateCell,
});

export const DateCell: DatatableCellRenderer<string, {}, PartialRowData> = ({
  renderValue,
  row,
}) => {
  const isDayLocked = !!row.original.isDayLocked;

  return (
    <Box.Row alignItems="center" height="100%" gap="small" className={styles.date}>
      <Text size="small" className={classNames('fs-mask', styles.label)}>
        {renderValue()}
      </Text>
      {isDayLocked && (
        <Tooltip tooltip="Day is locked">
          <Icon name="Lock01" type="solid" width={16} height={16} className={styles.icon} />
        </Tooltip>
      )}
    </Box.Row>
  );
};
